import * as React from "react";
import { BaseTemplate } from "templates/src/types";

interface SelectedTemplateContextValue {
  value: Record<string, any>;
  onValueChange: (value: any, key: string) => void;
  getValue: (key: string) => any;
  canGenerate: boolean;
  template: BaseTemplate;
  valuesToApiFormat: Record<string, any>;
}

const SelectedTemplateContext =
  React.createContext<SelectedTemplateContextValue | null>(null);

export const useSelectedTemplateContext = () => {
  const context = React.useContext(SelectedTemplateContext);
  if (!context) {
    throw new Error(
      "useSelectedTemplateContext must be used within a SelectedTemplateContextProvider"
    );
  }
  return context;
};

interface Props {
  children: React.ReactNode;
  template: BaseTemplate;
}

export const SelectedTemplateContextProvider = (props: Props) => {
  const { template, children } = props;

  const [value, setValue] = React.useState({});

  const onValueChange = (value: any, key: string) => {
    setValue((prev) => ({ ...prev, [key.toLowerCase()]: value }));
  };

  const getValue = (key: string) => {
    return value[key.toLowerCase()];
  };

  const canGenerate = template.fields.every((field) => {
    if (field.optional) {
      return true;
    }

    return !!getValue(field.id);
  });

  const valuesToApiFormat = {
    templateId: template.id,
    ...value,
  };

  const values = {
    template,
    value,
    onValueChange,
    getValue,
    canGenerate,
    valuesToApiFormat,
  };
  return (
    <SelectedTemplateContext.Provider value={values}>
      {children}
    </SelectedTemplateContext.Provider>
  );
};

export const useGetTemplate = () => {
  return useSelectedTemplateContext().template;
};
